module.exports = __webpack_public_path__ + "static/media/virbac_20210510.3ca83128.pdf";